/**
 * 顶部 Mega Menu 项外链（与翻译 key 对应，与语言无关）
 */
export const MEGA_MENU_EXTERNAL_URLS: Record<string, string> = {
  "menu.sol.geo": "http://orangeo.photog.art",
  "menu.sol.social": "http://tkfactory.photog.art",
  "menu.sol.email": "http://aigrowth.photog.art",
  "menu.sol.sales": "http://aisales.photog.art",
  "menu.ind.beauty": "https://industrysolution.photog.art/",
  "menu.ind.electronics": "https://industrysolution.photog.art/",
  "menu.ind.crossborder": "https://industrysolution.photog.art/",
  "menu.ind.data": "https://industrysolution.photog.art/",
  "menu.prod.dataInfra": "https://industrysolution.photog.art/",
  "menu.prod.insights": "https://insighthub.photog.art",
  "menu.prod.strategy": "https://strategyengine.photog.art",
  "menu.prod.contentFactory": "https://toolbox.photog.art",
  "menu.plat.dataCenter": "https://datacenter.oran.cn/",
  "menu.plat.skills": "https://skills.oran.cn/",
};
